// extracted by mini-css-extract-plugin
module.exports = {"tag-wrapper":"tag-wrapper--3FTjI","isAllTags":"isAllTags--2GvtW","more":"more--2G65Y"};